<div mat-dialog-content>
  <div>
    <h1 class="titleHeader">{{'label_header' | translate}}</h1>
  </div>
  <div class="item">
    <span>{{data.labelsCsv.separator_columns.label}}</span>
    <input [(ngModel)]="data.csv.fieldSeparator">
  </div>
  <div class="viewHeaderCheckbox">
    <mat-checkbox labelPosition="after" [(ngModel)]="data.csv.exportHead">
      {{data.labelsCsv.see_header.label}}
    </mat-checkbox>
  </div>
  <div class="item">
    <span>
      {{data.labelsCsv.separator_decimal.label}}
    </span>
    <input [(ngModel)]="data.csv.decimalSeparator">
  </div>
  <div class="item">
    <div class="item__content">
      <span>
        {{data.labelsCsv.filename.label}}
      </span>
      <span class="required">
        {{'title_subscriptionTypeCustomCircuit_Obligatorio' | translate}}
      </span>
    </div>
    <input [(ngModel)]="data.csv.filename">
  </div>
</div>
<div class="buttonContainer">
  <signaturit-button text="{{'cancel_text'|translate}}" type="tertiary" size="md"
  (click)="closeDialog()"></signaturit-button>
  <signaturit-button text="{{'finish_btn_descargar'|translate}}" type="secondary" size="md"
  (click)="data.submit(data)"></signaturit-button>
</div>
